/**
 * Dependencies
 */
import PropTypes from 'prop-types';
import appConfig from '@nerdwallet/app-config';
import GlobalMarkupOptions from '@nerdwallet/coin/GlobalMarkupOptions';

import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { isEqual } from 'lodash';
import { Impression } from '@nerdwallet/analytics/react/impression';
import {
  AnalyticsPageView,
  AnalyticsProvider,
} from '@nerdwallet/seo-analytics';
import { submitProductSearch, submitSearch } from '~/client/lib/actions';

import SearchPage from '~/client/components/search/search-page';

class SearchRoute extends Component {
  constructor(props) {
    super(props);
    // Get Initial State is deprecated. Define initial state in the constructor.
    this.state = {
      // Initial state goes here.
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({ params, resultsPerPage }) {
    // re-run search when query changes
    if (!isEqual(params, this.props.params)) {
      this.props.dispatch(
        submitSearch({
          searchTerm: params.searchTerm,
          page: params.page,
          facets: params.facets,
          resultsPerPage,
        })
      );
      this.props.dispatch(
        submitProductSearch({
          searchTerm: params.searchTerm,
        })
      );
    }
  }

  render() {
    const { dispatch, search, productSearch, resultsPerPage, history } =
      this.props;

    const { searchTerm: query, page, facets, s } = this.props.params;
    const suggestion = s === '1';

    const searchPageProps = {
      query,
      page,
      facets,
      suggestion,
      dispatch,
      search,
      productSearch,
      resultsPerPage,
      history,
    };
    const searchPageTitle = !(query || '').trim()
      ? 'NerdWallet Search'
      : `${query} - NerdWallet Search`;

    const searchResultsPage = 'search_results_page';
    const segmentTrackingOpts = {
      segmentTrackingAttributes: {
        driverPageName: searchResultsPage,
        // eslint-disable-next-line no-underscore-dangle
        deployableName: appConfig?._meta?.deployable,
        // eslint-disable-next-line no-underscore-dangle
        deployableVersion: appConfig?._meta?.version,
      },
    };
    return (
      <AnalyticsProvider>
        <AnalyticsPageView name={searchResultsPage}>
          <Impression
            eventType="page_impression"
            entityName={searchResultsPage}
            payload={{
              display_mode: 'standard',
            }}
          >
            <GlobalMarkupOptions>
              {{ ...segmentTrackingOpts }}
            </GlobalMarkupOptions>
            <DocumentTitle title={searchPageTitle} />
            <SearchPage {...searchPageProps} />
          </Impression>
        </AnalyticsPageView>
      </AnalyticsProvider>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
SearchRoute.displayName = 'SearchRoute';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
SearchRoute.propTypes = {
  dispatch: PropTypes.func.isRequired,
  search: PropTypes.object.isRequired,
  productSearch: PropTypes.object.isRequired,
  resultsPerPage: PropTypes.number,
  history: PropTypes.object,
  location: PropTypes.object,
  params: PropTypes.shape({
    searchTerm: PropTypes.string,
    page: PropTypes.number.isRequired,
    facets: PropTypes.object.isRequired,
    s: PropTypes.string,
  }),
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
SearchRoute.defaultProps = {
  resultsPerPage: 10,
};

// TODO: map this to what's necessary. Passing everything reduces performance
export default connect((state) => state)(SearchRoute);
